import { myAxios } from "./axios";

export function getAllWorkExperiences(data, { page, perPage }) {
  let config = {
    params: {
      page,
      perPage,
      ...(data || {}),
    },
  };
  return myAxios.get("/work-experience", config);
}

export function getSingleWorkExperience(id) {
  return myAxios.get("/work-experience/" + id);
}

export function addWorkExperience(data) {
  return myAxios.post("/work-experience/create", data);
}

export function editWorkExperience(id, data) {
  return myAxios.put("/work-experience/" + id + "/update", data);
}

export function deleteWorkExperience(id) {
  return myAxios.delete("/work-experience/" + id + "/delete");
}
